<template>
  <section class="dp-layout tr-page">
    <section class="dp-left">
      <DepartmentPane directory-scope="school" @tree-node-click="handleNodeClick" :type="1"></DepartmentPane>
    </section>
    <section class="dp-right">
      <header class="tr-hero">
        <div>
          <p class="tr-eyebrow">集体备课 · 文档管理</p>
          <h1 class="tr-title">备课文档</h1>
          <p class="tr-sub">查询全校备课文档与流程状态，详情内可按状态代操作。</p>
        </div>
        <div class="tr-hero__meta">
          <div class="tr-stat">
            <span>当前结果</span>
            <strong>{{ total != null ? total : (tableData && tableData.length) || 0 }}</strong>
          </div>
        </div>
      </header>

      <div class="tr-panel">
        <toolbar ref="toolbar" :buttonList="buttonList" @callFunction="callFunction" :searchList="searchList"></toolbar>

                <!-- 列表：tbl-scroll-host + height 表体占满、空状态可见。最后更新：2026-08-31 -->
                <div class="tbl-scroll-host">
                <el-table height="100%" :data="tableData" v-loading="listLoading" class="tr-table" style="width: 100%">
          <el-table-column prop="Title" label="文档标题" min-width="140">
            <template slot-scope="scope">
              <span class="tr-name">{{ scope.row.Title }}</span>
            </template>
          </el-table-column>
          <el-table-column label="备课内容" width="100">
            <template slot-scope="scope">
              <div class="v9-content-ellipsis" :title="scope.row.Content">
                {{ scope.row.Content || '-' }}
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="GroupName" label="教研组" min-width="100"></el-table-column>
          <el-table-column prop="UploaderName" label="上传教师" width="100"></el-table-column>
          <el-table-column label="多媒体" width="130" align="center">
            <template slot-scope="scope">
              <div v-if="scope.row.Attachments && scope.row.Attachments.length">
                <el-tag size="mini" type="info" v-for="(count, ext) in getAttachmentCounts(scope.row.Attachments)"
                  :key="ext" style="margin: 1px">
                  {{ count }}个{{ ext }}
                </el-tag>
              </div>
              <span v-else class="tr-muted">-</span>
            </template>
          </el-table-column>
          <el-table-column label="绑定课时" min-width="200">
            <template slot-scope="scope">
              <span
                v-if="(scope.row.BoundLessons && scope.row.BoundLessons.length) || (scope.row.LessonLabels && scope.row.LessonLabels.length)"
                class="pd-lesson-link" @click="openLessonLabelsDialog(scope.row)">
                <span class="pd-lesson-link__text" :title="docLessonPreview(scope.row)">{{ docLessonPreview(scope.row)
                }}</span>
                <span v-if="docLessonCount(scope.row) > 1"> 等 {{ docLessonCount(scope.row) }} 个</span>
                <i class="el-icon-view"></i>
              </span>
              <el-tag v-else-if="scope.row.IsLegacyDoc" size="mini" type="info">一期旧文档</el-tag>
              <span v-else class="tr-muted">—</span>
            </template>
          </el-table-column>
          <el-table-column label="流程状态" width="110" align="center">
            <template slot-scope="scope">
              <el-tag size="mini" :type="workflowTagType(scope.row.WorkflowStatus)">
                {{ scope.row.WorkflowStatusText || '—' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="2.0修订" width="90" align="center">
            <template slot-scope="scope">{{ scope.row.CurrentRevisionText || '无' }}</template>
          </el-table-column>
          <el-table-column label="投票进度" width="110" align="center">
            <template slot-scope="scope">{{ scope.row.VoteProgressText || '—' }}</template>
          </el-table-column>
          <el-table-column prop="ViewCount" label="查阅数" width="80" align="center"></el-table-column>
          <el-table-column prop="TotalScore" label="总评分" width="80" align="center"></el-table-column>
          <el-table-column prop="UploadTime" label="上传时间" width="170"></el-table-column>
          <el-table-column label="状态" width="100" align="center">
            <template slot-scope="scope">
              <el-tag :type="scope.row.IsHistory ? 'danger' : 'success'" size="mini">
                {{ scope.row.IsHistory ? '已归档' : '进行中' }}
              </el-tag>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="90" align="center" fixed="right">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="handleDetail(scope.row)">详情</el-button>
            </template>
          </el-table-column>
        </el-table>
                </div>

        <div class="tr-pager">
          <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
            :current-page="filters.Page" :page-sizes="[10, 20, 50, 100]" :page-size="filters.PageSize"
            layout="total, sizes, prev, pager, next, jumper" :total="total" />
        </div>
      </div>

      <!-- 备课明细：蓝橙信息层级弹窗 -->
      <el-dialog :visible.sync="detailVisible" width="1080px" top="5vh" custom-class="pp-detail-dialog"
        :close-on-click-modal="false" append-to-body>
        <div slot="title" class="pp-dialog-title">
          <span class="pp-dialog-title__mark"></span>
          <div>
            <div class="pp-dialog-title__main">备课明细</div>
            <div class="pp-dialog-title__sub">查看内容与流程节点，卡住时在底部处理</div>
          </div>
        </div>

        <div v-if="detailData" class="pp-detail">
          <header class="pp-hero">
            <div class="pp-hero__top">
              <h2 class="pp-hero__title">{{ detailData.Document.Title }}</h2>
              <span class="pp-status" :class="'pp-status--' + workflowStatusTone(detailData.WorkflowStatus)">{{
                detailData.WorkflowStatusText || '无流程' }}</span>
            </div>

            <ul class="pp-meta">
              <li>
                <span class="pp-meta__k">教研组</span>
                <span class="pp-meta__v">{{ detailData.Document.GroupName || '—' }}</span>
              </li>
              <li>
                <span class="pp-meta__k">上传教师</span>
                <span class="pp-meta__v">{{ detailData.Document.UploaderName || '—' }}</span>
              </li>
              <li>
                <span class="pp-meta__k">上传时间</span>
                <span class="pp-meta__v">{{ detailData.Document.UploadTime || '—' }}</span>
              </li>
              <li>
                <span class="pp-meta__k">公共库</span>
                <span class="pp-meta__v">{{
                  detailData.LibraryItem
                    ? (detailData.LibraryItem.Status === 1 ? '已发布' : '已下架')
                    : '未入库'
                }}</span>
              </li>
              <li class="pp-meta__op">
                <span class="pp-meta__k">操作人</span>
                <span class="pp-meta__v">{{ detailData.OperatorName || '未指定' }}</span>
                <button type="button" class="pp-link" @click="openTransfer">交接</button>
              </li>
            </ul>

            <div v-if="detailData.Lessons && detailData.Lessons.length" class="pp-lessons">
              <span class="pp-lessons__label">绑定课时</span>
              <span v-for="l in detailData.Lessons" :key="l.LessonId" class="pp-chip" :title="formatLessonChip(l)">{{
                formatLessonChip(l) }}</span>
            </div>
            <div v-else-if="detailData.Document && detailData.Document.IsLegacyDoc" class="pp-callout">
              <i class="el-icon-warning-outline"></i>
              <div class="pp-callout__body">
                <strong>一期旧文档</strong>
                <span>尚未绑定课时，补绑后可纳入二期目录统计</span>
              </div>
              <button type="button" class="pp-callout__btn" @click="openBindLessons">去补绑</button>
            </div>
          </header>

          <el-tabs v-model="detailTab" class="pp-tabs">
            <el-tab-pane name="content">
              <span slot="label" class="pp-tab-label">内容</span>
              <div class="pp-pane">
                <section class="pp-block" v-if="detailData.Document.Content">
                  <h3 class="pp-block__title">教案说明</h3>
                  <div class="pp-prose">{{ detailData.Document.Content }}</div>
                </section>
                <section class="pp-block">
                  <h3 class="pp-block__title">附件</h3>
                  <div class="pp-files"
                    v-if="detailData.Document.Attachments && detailData.Document.Attachments.length">
                    <div v-for="file in detailData.Document.Attachments" :key="file.Id" class="pp-file">
                      <button type="button" class="pp-file__main" @click="handlePreview(file)">
                        <i :class="getFileIcon(file.FileType)" class="pp-file__icon"></i>
                        <span class="pp-file__name">{{ file.FileName }}</span>
                        <span v-if="file.FileSize && Number(file.FileSize) > 0" class="pp-file__size">{{ (file.FileSize
                          /
                          1024).toFixed(1) }} KB</span>
                      </button>
                      <div class="pp-file__ops">
                        <button type="button" class="pp-icon-btn" title="预览" @click="handlePreview(file)">
                          <i class="el-icon-view"></i>
                        </button>
                        <oss-media-link :path="file.FileUrl" class="pp-file__dl">
                          <span class="pp-icon-btn is-dl" title="下载"><i class="el-icon-download"></i></span>
                        </oss-media-link>
                      </div>
                    </div>
                  </div>
                  <div v-else class="pp-empty">暂无附件</div>
                </section>
              </div>
            </el-tab-pane>

            <el-tab-pane name="review">
              <span slot="label" class="pp-tab-label">
                评价
                <em>{{ (detailData.Reviews && detailData.Reviews.length) || 0 }}</em>
              </span>
              <div class="pp-pane">
                <div v-if="detailData.Reviews && detailData.Reviews.length" class="pp-review-list">
                  <article v-for="review in paginatedReviews" :key="review.Id" class="pp-review">
                    <header class="pp-review__head">
                      <strong>{{ review.ReviewerName }}</strong>
                      <span v-if="review.Score > 0" class="pp-pill pp-pill--amber">{{ review.Score }}分</span>
                      <span :class="review.IsValid ? 'pp-pill pp-pill--ok' : 'pp-pill'">{{ review.IsValid ? '有效' : '无效'
                      }}</span>
                      <span class="pp-pill">认可 {{ review.EndorseCount || 0 }}</span>
                      <span v-if="review.HasDiscussion" class="pp-pill pp-pill--warn">已开讨论</span>
                      <time>{{ review.ReviewTime }}</time>
                    </header>
                    <p v-if="review.CommentContent" class="pp-review__body">{{ review.CommentContent }}</p>
                  </article>
                  <div v-if="detailData.Reviews.length > reviewPageSize" class="pp-pager">
                    <el-pagination small layout="prev, pager, next" :current-page.sync="reviewPage"
                      :page-size="reviewPageSize" :total="detailData.Reviews.length" />
                  </div>
                </div>
                <div v-else class="pp-empty">暂无评价</div>
              </div>
            </el-tab-pane>

            <el-tab-pane name="discussion">
              <span slot="label" class="pp-tab-label">
                讨论
                <em>{{ (detailData.Discussions && detailData.Discussions.length) || 0 }}</em>
              </span>
              <div class="pp-pane">
                <el-collapse v-if="detailData.Discussions && detailData.Discussions.length"
                  v-model="activeDiscussionIds" class="pp-collapse">
                  <el-collapse-item v-for="d in detailData.Discussions" :key="d.Id" :name="String(d.Id)">
                    <template slot="title">
                      <span class="pp-collapse__title">
                        {{ d.CreateByName || '组员' }}
                        <span :class="d.Status === 1 ? 'pp-pill' : 'pp-pill pp-pill--warn'">
                          {{ d.Status === 1 ? '已结束' : '进行中' }}
                        </span>
                        <time>{{ d.CreateTime }}</time>
                      </span>
                    </template>
                    <div v-for="m in (d.Messages || [])" :key="m.Id" class="pp-msg">
                      <div class="pp-msg__meta">
                        {{ m.TeacherName }} · {{ m.MessageType === 2 ? '成果' : '发言' }} · {{ m.CreateTime }}
                        <span v-if="m.RevisionDocId"> · 修订#{{ m.RevisionDocId }}</span>
                      </div>
                      <div class="pp-msg__text">{{ m.Content || '—' }}</div>
                    </div>
                    <div v-if="!d.Messages || !d.Messages.length" class="pp-empty pp-empty--sm">暂无消息</div>
                    <div v-if="d.Status === 0" class="pp-collapse__foot">
                      <el-button type="warning" plain size="mini" @click="adminEndDiscussion(d)">代结束讨论</el-button>
                    </div>
                  </el-collapse-item>
                </el-collapse>
                <div v-else class="pp-empty">暂无讨论</div>
              </div>
            </el-tab-pane>

            <el-tab-pane name="revision">
              <span slot="label" class="pp-tab-label">
                修订
                <em>{{ (detailData.Revisions && detailData.Revisions.length) || 0 }}</em>
              </span>
              <div class="pp-pane">
                <el-table v-if="detailData.Revisions && detailData.Revisions.length" :data="detailData.Revisions"
                  size="small" class="pp-table">
                  <el-table-column prop="RevisionNo" label="修订号" width="80" />
                  <el-table-column prop="Title" label="标题" />
                  <el-table-column prop="UploadTime" label="提交时间" width="170" />
                  <el-table-column label="附件" width="80" align="center">
                    <template slot-scope="scope">{{ (scope.row.Attachments && scope.row.Attachments.length) || 0
                    }}</template>
                  </el-table-column>
                </el-table>
                <div v-else class="pp-empty">暂无 2.0 修订</div>
              </div>
            </el-tab-pane>

            <el-tab-pane name="vote">
              <span slot="label" class="pp-tab-label">
                投票
                <em>{{ (detailData.Votes && detailData.Votes.length) || 0 }}</em>
              </span>
              <div class="pp-pane">
                <el-table v-if="detailData.Votes && detailData.Votes.length" :data="detailData.Votes" size="small"
                  class="pp-table">
                  <el-table-column prop="Id" label="投票ID" width="140" />
                  <el-table-column label="状态" width="90" align="center">
                    <template slot-scope="scope">
                      <el-tag size="mini" :type="voteStatusTagType(scope.row.Status)">
                        {{ voteStatusText(scope.row.Status) }}
                      </el-tag>
                    </template>
                  </el-table-column>
                  <el-table-column label="进度" width="160">
                    <template slot-scope="scope">
                      {{ scope.row.Status === 0
                        ? ((scope.row.AgreeCount + scope.row.ImproveCount) + '/' + scope.row.EligibleVoterCount)
                        : ('同意' + scope.row.AgreeCount + '/需改进' + scope.row.ImproveCount) }}
                    </template>
                  </el-table-column>
                  <el-table-column prop="PassPercent" label="阈值%" width="70" />
                  <el-table-column prop="StartTime" label="开始" width="160" />
                  <el-table-column prop="EndTime" label="结束" width="160" />
                  <el-table-column label="结束原因" min-width="120">
                    <template slot-scope="scope">
                      {{ voteCloseReasonText(scope.row.CloseReason) }}
                    </template>
                  </el-table-column>
                </el-table>
                <div v-else class="pp-empty">暂无投票</div>
              </div>
            </el-tab-pane>
          </el-tabs>
        </div>

        <div slot="footer" class="pp-footer">
          <div class="pp-footer__left">
            <el-button v-if="detailPrimaryAction === 'closeVote'" type="warning" size="small"
              @click="adminCloseVote({ CurrentVoteId: detailData.CurrentVoteId })">代结票</el-button>
            <el-button v-else-if="detailPrimaryAction === 'publish'" type="primary" size="small" class="pp-btn-primary"
              @click="adminPublish({ RootDocId: detailData.Document.RootDocId || detailData.Document.Id })">代发布公共库</el-button>
            <el-button v-else-if="detailPrimaryAction === 'unpublish'" type="danger" plain size="small"
              @click="adminUnpublishFromDetail">代下架</el-button>
            <el-button v-if="detailUrgeMenuItem" type="text" size="small"
              @click="onDetailMoreCommand(detailUrgeMenuItem.command)">{{ detailUrgeMenuItem.label }}</el-button>
          </div>
          <el-button size="small" @click="detailVisible = false">关闭</el-button>
        </div>
      </el-dialog>

      <el-dialog title="交接操作人" :visible.sync="transferVisible" width="460px" append-to-body>
        <el-form label-width="100px" size="small">
          <el-form-item label="组内教师" required>
            <el-select v-model="transferMasterId" filterable clearable placeholder="请选择组内教师" style="width:100%">
              <el-option v-for="t in groupTeacherOptions" :key="t.TeacherMasterId" :label="t.TeacherName"
                :value="t.TeacherMasterId" />
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="transferVisible = false">取消</el-button>
          <el-button type="primary" :loading="transferSaving" @click="submitTransfer">确定</el-button>
        </div>
      </el-dialog>

      <el-dialog title="补绑课时" :visible.sync="bindVisible" width="520px" append-to-body>
        <el-form label-width="90px" size="small">
          <el-form-item label="课本册" required>
            <el-select v-model="bindTextbookId" placeholder="选择课本册" style="width:100%" @change="onBindTextbookChange">
              <el-option v-for="b in bindTextbooks" :key="b.Id" :label="b.Title" :value="b.Id" />
            </el-select>
          </el-form-item>
          <el-form-item label="课时" required>
            <el-select v-model="bindLessonIds" multiple filterable placeholder="选择课时（可多选）" style="width:100%">
              <el-option v-for="l in bindLessonOptions" :key="l.value" :label="l.label" :value="l.value" />
            </el-select>
          </el-form-item>
        </el-form>
        <div slot="footer">
          <el-button @click="bindVisible = false">取消</el-button>
          <el-button type="primary" :loading="bindSaving" @click="submitBindLessons">保存绑定</el-button>
        </div>
      </el-dialog>

      <!-- 内网 Office 预览提示 -->
      <el-dialog :visible.sync="previewHintVisible" width="480px" append-to-body custom-class="wr-preview-hint-dialog"
        :show-close="true" :close-on-click-modal="false" @closed="onPreviewHintClosed">
        <div class="wr-hint">
          <div class="wr-hint__hero">
            <div class="wr-hint__icon" aria-hidden="true">
              <i class="el-icon-warning-outline"></i>
            </div>
            <h3 class="wr-hint__title">预览环境受限</h3>
            <p class="wr-hint__desc">
              当前运行在<strong>私有内网</strong>，微软 Office 在线预览无法访问本地文件，请下载后使用本地 Office 查看。
            </p>
          </div>
          <div class="wr-hint__steps">
            <div class="wr-hint__step">
              <span class="wr-hint__step-no">1</span>
              <div class="wr-hint__step-body">
                <div class="wr-hint__step-title">下载到本地查看</div>
                <div class="wr-hint__step-text">点击详情中的下载按钮，用 Word / Excel / PPT 打开。</div>
              </div>
            </div>
            <div class="wr-hint__step">
              <span class="wr-hint__step-no">2</span>
              <div class="wr-hint__step-body">
                <div class="wr-hint__step-title">公网部署后自动可用</div>
                <div class="wr-hint__step-text">系统部署到公网服务器后，在线预览将自动生效。</div>
              </div>
            </div>
          </div>
          <div v-if="previewHintFile" class="wr-hint__file">
            <i :class="getFileIcon(previewHintFile.FileType)"></i>
            <span class="wr-hint__file-name">{{ previewHintFile.FileName }}</span>
          </div>
        </div>
        <span slot="footer" class="wr-hint__footer">
          <el-button @click="previewHintVisible = false">知道了</el-button>
          <oss-media-link v-if="previewHintFile" :path="previewHintFile.FileUrl" :download="true"
            class="wr-hint__dl-link">
            <el-button type="primary" icon="el-icon-download">下载文件</el-button>
          </oss-media-link>
        </span>
      </el-dialog>

      <!-- 独立的文件预览弹窗 -->
      <el-dialog title="文件预览" :visible.sync="previewVisible" width="96vw" top="1vh"
        custom-class="premium-dialog is-preview-mode" append-to-body :close-on-click-modal="false">
        <div class="preview-container">
          <div class="preview-toolbar" style="display: flex; justify-content: space-between; align-items: center;">
            <span class="preview-filename">{{ currentPreviewName }}</span>
            <div style="font-size: 13px; color: #e6a23c; margin: 0 15px; display: flex; align-items: center;">
              <i class="el-icon-warning-outline" style="margin-right: 5px; font-size: 15px;"></i>
              若在线预览失败或提示报错，您可以直接：
              <a :href="previewUrlRaw" target="_blank"
                style="color: var(--btn-primary, #2563eb); font-weight: bold; text-decoration: underline; margin-left: 5px;">在新窗口打开</a>
              或从下方选项下载。
            </div>
            <div class="preview-actions">
              <a :href="previewUrlRaw" target="_blank">
                <el-button icon="el-icon-full-screen" type="text">全屏查看</el-button>
              </a>
            </div>
          </div>
          <div class="preview-frame-wrapper">
            <iframe v-if="previewVisible" :src="previewUrl" frameborder="0" class="preview-iframe"></iframe>
          </div>
        </div>
      </el-dialog>

      <!-- 绑定课时完整列表 -->
      <el-dialog :visible.sync="lessonLabelsVisible" width="520px" append-to-body title="绑定课时">
        <p class="pd-lesson-dialog__sub">
          {{ lessonLabelsDocTitle || "教案" }} · 共 {{ lessonLabelsList.length }} 个
        </p>
        <div v-if="lessonLabelsList.length" class="pd-lesson-dialog__list">
          <div v-for="(lb, idx) in lessonLabelsList" :key="idx" class="pd-lesson-dialog__item">
            <div class="pd-lesson-dialog__path">{{ lessonItemPath(lb) }}</div>
            <div v-if="lessonItemName(lb)" class="pd-lesson-dialog__name">课时名称：{{ lessonItemName(lb) }}</div>
            <div v-else class="pd-lesson-dialog__name is-empty">未填课时名称</div>
          </div>
        </div>
        <div v-else class="tr-muted">暂无绑定课时</div>
        <div slot="footer">
          <el-button type="primary" @click="lessonLabelsVisible = false">关闭</el-button>
        </div>
      </el-dialog>

    </section>
  </section>
</template>

<script>
import {
  getPrepDocumentPageForAdmin,
  getAllGroups,
  getPrepDocumentDetail,
  exportPrepDocument,
  adminCloseVote,
  adminPublishToLibrary,
  adminUnpublishFromLibrary,
  transferDocumentOperator,
  adminEndDiscussion,
  adminBindLessons,
  getGroupTeachers,
  getTextbooks,
  getCatalogTree,
  urgePrepDocument
} from '../../api/modules/teaching-research';
import { BaseApiUrl } from '../../api/base';
import { getButtonList } from "@/promissionRouter";
import Toolbar from "@/components/Toolbar";
import DepartmentPane from "@/components/DepartmentPane";
import util from "@/../util/date";
import { resolveAttachmentAccessUrl, stripOssUrlQuery } from "@/utils/mediaUrl";
import { getUploadSchoolId } from "@/utils/ossMediaUpload";
import { normalizeDeptId } from "@/utils/deptCascaderProps";

export default {
  name: "PrepDocument",
  components: { Toolbar, DepartmentPane },
  data() {
    return {
      filters: {
        Page: 1,
        PageSize: 10,
        GroupId: null,
        Title: "",
        UploaderUid: null,
        UploadTimeFrom: null,
        UploadTimeTo: null,
        WorkflowStatus: null,
        TextbookId: null,
        UnitId: null,
        AssignedTeacherMasterId: null,
        OnlyLegacyDoc: null
      },
      tableData: [],
      total: 0,
      listLoading: false,
      buttonList: [],
      searchList: [
        { label: "教研组", key: "GroupId", type: "select", options: [], initValue: null },
        { label: "课本册", key: "TextbookId", type: "select", options: [], initValue: null },
        { label: "单元", key: "UnitId", type: "select", options: [], initValue: null },
        { label: "安排教师", key: "AssignedTeacherMasterId", type: "select", options: [], initValue: null },
        { label: "文档标题", key: "Title", type: "input", placeholder: "标题关键词", initValue: "" },
        {
          label: "流程状态",
          key: "WorkflowStatus",
          type: "select",
          initValue: null,
          options: [
            { label: "全部", value: null },
            { label: "待评价", value: 10 },
            { label: "评价中", value: 20 },
            { label: "讨论中", value: 30 },
            { label: "待提交2.0", value: 35 },
            { label: "投票中", value: 40 },
            { label: "未通过", value: 50 },
            { label: "已通过", value: 60 },
            { label: "已入库", value: 70 }
          ]
        },
        {
          label: "异常",
          key: "OnlyLegacyDoc",
          type: "select",
          initValue: null,
          options: [
            { label: "全部", value: null },
            { label: "仅一期旧文档", value: true }
          ]
        },
        { label: "上传开始", key: "UploadTimeFrom", type: "date", initValue: null },
        { label: "上传结束", key: "UploadTimeTo", type: "date", initValue: null }
      ],
      groupOptions: [],
      SchoolId: null,
      BaseApiUrl: BaseApiUrl,

      detailVisible: false,
      detailData: null,
      detailTab: "content",
      activeDiscussionIds: [],
      transferVisible: false,
      transferMasterId: null,
      transferSaving: false,
      groupTeacherOptions: [],
      bindVisible: false,
      bindSaving: false,
      bindTextbookId: null,
      bindLessonIds: [],
      bindTextbooks: [],
      bindLessonOptions: [],
      // 预览相关
      previewVisible: false,
      previewUrl: '',
      previewUrlRaw: '',
      currentPreviewName: '',
      previewHintVisible: false,
      previewHintFile: null,
      lessonLabelsVisible: false,
      lessonLabelsDocTitle: "",
      lessonLabelsList: [],
      // 评价分页
      reviewPage: 1,
      reviewPageSize: 5
    };
  },
  computed: {
    paginatedReviews() {
      if (!this.detailData || !this.detailData.Reviews) return [];
      const start = (this.reviewPage - 1) * this.reviewPageSize;
      const end = start + this.reviewPageSize;
      return this.detailData.Reviews.slice(start, end);
    },
    /**
     * 详情底部主操作：只在流程真正卡住时出现一个。
     * 补绑课时改到标题区，避免和「催办」挤在一起。
     */
    detailPrimaryAction() {
      if (!this.detailData) return "";
      if (this.detailData.WorkflowStatus === 40 && this.detailData.CurrentVoteId) return "closeVote";
      if (this.detailData.WorkflowStatus === 60) return "publish";
      if (this.detailData.LibraryItem && this.detailData.LibraryItem.Status === 1) return "unpublish";
      return "";
    },
    /** 按工作流状态只给一条催办，无关项不展示 */
    detailUrgeMenuItem() {
      if (!this.detailData) return null;
      const wf = this.detailData.WorkflowStatus;
      if (wf === 10 || wf === 20) return { command: "urgeReview", label: "催评价" };
      if (wf === 40) return { command: "urgeVote", label: "催投票" };
      if (wf === 35 || wf === 50) return { command: "urgeV2", label: "催交2.0" };
      if (wf === 60) return { command: "urgePublish", label: "催发布" };
      return null;
    }
  },
  methods: {
    /** 查看绑定课时完整列表 */
    openLessonLabelsDialog(row) {
      if (!row) return;
      this.lessonLabelsDocTitle = row.Title || row.title || "";
      const bound = row.BoundLessons || row.boundLessons || [];
      if (bound.length) {
        this.lessonLabelsList = bound.slice();
      } else {
        this.lessonLabelsList = (row.LessonLabels || row.lessonLabels || []).slice();
      }
      this.lessonLabelsVisible = true;
    },
    /** 课时路径（册/单元-类型-序号） */
    lessonItemPath(item) {
      if (item == null) return "—";
      if (typeof item === "string") {
        return String(item).replace(/（[^）]*）\s*$/, "").replace(/·[^·]*$/, "") || item;
      }
      const book = item.TextbookTitle || item.textbookTitle || "";
      const unit = item.UnitName || item.unitName || "";
      const typeText = Number(item.LessonType || item.lessonType) === 2 ? "练习" : "新授";
      const no = item.LessonNo != null ? item.LessonNo : item.lessonNo;
      const base = `${unit}-${typeText}-${no}`;
      return book ? `${book}/${base}` : base;
    },
    /** 课时名称 */
    lessonItemName(item) {
      if (item == null) return "";
      if (typeof item === "string") {
        const m = String(item).match(/（([^）]+)）\s*$/);
        if (m) return m[1];
        const parts = String(item).split("·");
        return parts.length > 1 ? parts[parts.length - 1] : "";
      }
      return (item.LessonName || item.lessonName || "").trim();
    },
    docLessonCount(row) {
      if (!row) return 0;
      const bound = row.BoundLessons || row.boundLessons || [];
      if (bound.length) return bound.length;
      return (row.LessonLabels || row.lessonLabels || []).length;
    },
    docLessonPreview(row) {
      if (!row) return "";
      const bound = row.BoundLessons || row.boundLessons || [];
      if (bound.length) {
        const first = bound[0];
        const path = this.lessonItemPath(first);
        const name = this.lessonItemName(first);
        return name ? `${path}（${name}）` : path;
      }
      const labels = row.LessonLabels || row.lessonLabels || [];
      return labels[0] || "";
    },
    /** 详情绑定课时展示：优先用含课时名的 Label，否则拼 LessonName */
    formatLessonChip(l) {
      if (!l) return "—";
      const label = (l.Label || l.label || "").trim();
      if (label) return label;
      const unit = l.UnitName || l.unitName || "";
      const typeText = Number(l.LessonType || l.lessonType) === 2 ? "练习" : "新授";
      const no = l.LessonNo != null ? l.LessonNo : l.lessonNo;
      const name = (l.LessonName || l.lessonName || "").trim();
      const base = `${unit}-${typeText}-${no}`;
      return name ? `${base}（${name}）` : base;
    },
    workflowTagType(status) {
      if (status === 70) return "success";
      if (status === 60) return "";
      if (status === 50) return "danger";
      if (status === 40) return "warning";
      if (status === 30 || status === 35) return "warning";
      return "info";
    },
    /** 投票轮次状态文案 */
    voteStatusText(status) {
      if (status === 0) return "进行中";
      if (status === 1) return "已通过";
      return "未通过";
    },
    /** 投票结束原因中文。创建于 2026-07-28 */
    voteCloseReasonText(reason) {
      const raw = (reason || "").trim();
      if (!raw) return "—";
      if (raw === "ManualClose") return "手动结束";
      if (raw === "FullTurnout") return "全员投完";
      if (raw === "Replaced") return "被新一轮替换";
      if (raw.indexOf("AdminClose") === 0) return "后台代结束";
      return raw;
    },
    /** 投票轮次状态标签色 */
    voteStatusTagType(status) {
      if (status === 0) return "warning";
      if (status === 1) return "success";
      return "danger";
    },
    /** 详情状态胶囊色调（文案+色同时表达，不只靠颜色） */
    workflowStatusTone(status) {
      if (status === 70) return "ok";
      if (status === 60) return "ready";
      if (status === 50) return "fail";
      if (status === 40 || status === 30 || status === 35) return "warn";
      if (status === 10 || status === 20) return "info";
      return "muted";
    },
    adminCloseVote(row) {
      this.$confirm("确认代结束该教案投票并结算？", "提示", { type: "warning" })
        .then(() => adminCloseVote({ VoteId: row.CurrentVoteId }))
        .then(res => {
          if (res.success) {
            this.$message.success(res.msg || "已代结票");
            this.getList();
          } else {
            this.$message.error(res.msg || "操作失败");
          }
        })
        .catch(() => { });
    },
    adminPublish(row) {
      this.$confirm("确认代发布该教案到公共库？", "提示", { type: "info" })
        .then(() => adminPublishToLibrary({ RootDocId: row.RootDocId || row.Id }))
        .then(res => {
          if (res.success) {
            this.$message.success(res.msg || "已代发布");
            this.detailVisible = false;
            this.getList();
          } else {
            this.$message.error(res.msg || "操作失败");
          }
        })
        .catch(() => { });
    },
    adminUnpublishFromDetail() {
      if (!this.detailData || !this.detailData.Document) return;
      const rootDocId = this.detailData.Document.RootDocId || this.detailData.Document.Id;
      this.$confirm("下架后组员将无法在公共库查看，确认下架？", "提示", { type: "warning" })
        .then(() => adminUnpublishFromLibrary({ RootDocId: rootDocId }))
        .then(res => {
          if (res.success) {
            this.$message.success(res.msg || "已代下架");
            this.detailVisible = false;
            this.getList();
          } else {
            this.$message.error(res.msg || "操作失败");
          }
        })
        .catch(() => { });
    },
    openTransfer() {
      if (!this.detailData || !this.detailData.Document) return;
      this.transferMasterId = this.detailData.OperatorTeacherMasterId || null;
      this.groupTeacherOptions = [];
      this.transferVisible = true;
      getGroupTeachers({ groupId: this.detailData.Document.GroupId }).then(res => {
        if (res.success) this.groupTeacherOptions = res.response || [];
        else this.$message.error(res.msg || "加载组员失败");
      });
    },
    submitTransfer() {
      if (!this.detailData || !this.detailData.Document) return;
      if (!this.transferMasterId) {
        this.$message.error("请选择组内教师");
        return;
      }
      this.transferSaving = true;
      transferDocumentOperator({
        RootDocId: this.detailData.Document.RootDocId || this.detailData.Document.Id,
        OperatorTeacherMasterId: this.transferMasterId
      })
        .then(res => {
          if (res.success) {
            this.$message.success(res.msg || "已交接");
            this.transferVisible = false;
            this.handleDetail(this.detailData.Document);
          } else {
            this.$message.error(res.msg || "交接失败");
          }
        })
        .finally(() => {
          this.transferSaving = false;
        });
    },
    adminEndDiscussion(d) {
      if (!d || !d.Id) return;
      this.$confirm("确认代结束该讨论？结束后若无其它进行中讨论将进入「待提交2.0」", "提示", { type: "warning" })
        .then(() => adminEndDiscussion({ DiscussionId: d.Id }))
        .then(res => {
          if (res.success) {
            this.$message.success(res.msg || "已结束讨论");
            this.handleDetail(this.detailData.Document);
            this.getList();
          } else {
            this.$message.error(res.msg || "操作失败");
          }
        })
        .catch(() => { });
    },
    openBindLessons() {
      if (!this.detailData || !this.detailData.Document) return;
      this.bindTextbookId = null;
      this.bindLessonIds = [];
      this.bindLessonOptions = [];
      this.bindVisible = true;
      getTextbooks({ groupId: this.detailData.Document.GroupId }).then(res => {
        if (res.success) this.bindTextbooks = res.response || [];
        else this.$message.error(res.msg || "加载课本册失败");
      });
    },
    onBindTextbookChange(textbookId) {
      this.bindLessonIds = [];
      this.bindLessonOptions = [];
      if (!textbookId) return;
      getCatalogTree({ textbookId }).then(res => {
        if (!res.success) return;
        const tree = res.response || {};
        const units = tree.Units || tree.units || [];
        const opts = [];
        units.forEach(u => {
          (u.Lessons || u.lessons || []).forEach(l => {
            const typeText = l.LessonType === 1 ? "新授" : "练习";
            opts.push({
              value: l.Id,
              label: `${u.UnitName}-${typeText}-${l.LessonNo}${l.LessonName ? " " + l.LessonName : ""}`
            });
          });
        });
        this.bindLessonOptions = opts;
      });
    },
    submitBindLessons() {
      if (!this.detailData || !this.detailData.Document) return;
      if (!this.bindLessonIds || !this.bindLessonIds.length) {
        this.$message.error("请至少选择一个课时");
        return;
      }
      this.bindSaving = true;
      adminBindLessons({
        RootDocId: this.detailData.Document.RootDocId || this.detailData.Document.Id,
        LessonIds: this.bindLessonIds
      })
        .then(res => {
          if (res.success) {
            this.$message.success(res.msg || "已绑定");
            this.bindVisible = false;
            this.handleDetail(this.detailData.Document);
            this.getList();
          } else {
            this.$message.error(res.msg || "绑定失败");
          }
        })
        .finally(() => {
          this.bindSaving = false;
        });
    },
    urgeFromDetail(urgeType) {
      if (!this.detailData || !this.detailData.Document || !this.SchoolId) return;
      urgePrepDocument({
        SchoolId: this.SchoolId,
        UrgeType: urgeType,
        RootDocId: this.detailData.Document.RootDocId || this.detailData.Document.Id
      }).then(res => {
        if (res.success) this.$message.success(res.msg || "已催办");
        else this.$message.error(res.msg || "催办失败");
      });
    },
    onDetailMoreCommand(cmd) {
      if (cmd === "closeVote") {
        this.adminCloseVote({ CurrentVoteId: this.detailData.CurrentVoteId });
      } else if (cmd === "publish") {
        this.adminPublish({
          RootDocId: this.detailData.Document.RootDocId || this.detailData.Document.Id
        });
      } else if (cmd === "unpublish") {
        this.adminUnpublishFromDetail();
      } else if (cmd === "bindLesson") {
        this.openBindLessons();
      } else if (cmd === "transfer") {
        this.openTransfer();
      } else if (cmd === "urgeReview") {
        this.urgeFromDetail("NeedReview");
      } else if (cmd === "urgeVote") {
        this.urgeFromDetail("NeedVote");
      } else if (cmd === "urgeV2") {
        this.urgeFromDetail("NeedV2");
      } else if (cmd === "urgePublish") {
        this.urgeFromDetail("NeedPublish");
      }
    },
    // 获取列表
    getList() {
      if (!normalizeDeptId(this.SchoolId)) {
        this.$message({ message: "当前处于总平台状态，请先从左侧选择具体的机构/学校再进行查询", type: "error" });
        return;
      }
      this.listLoading = true;
      const params = {
        ...this.filters,
        SchoolId: this.SchoolId,
        OnlyVersion1: true
      };
      getPrepDocumentPageForAdmin(params)
        .then(res => {
          if (res.success) {
            this.tableData = (res.response.data || []).map(x => ({
              ...x,
              Title: x.Title || x.title || "",
              GroupName: x.GroupName || x.groupName || "",
              LessonLabels: x.LessonLabels || x.lessonLabels || [],
              BoundLessons: x.BoundLessons || x.boundLessons || [],
              IsLegacyDoc: x.IsLegacyDoc != null ? x.IsLegacyDoc : x.isLegacyDoc
            }));
            this.total = res.response.dataCount;
          } else {
            this.$message.error(res.msg || "获取文档列表失败");
          }
        })
        .finally(() => {
          this.listLoading = false;
        });
    },
    // 加载教研组下拉
    loadGroups(schoolId) {
      getAllGroups({ SchoolId: schoolId || 0 }).then(res => {
        if (res.success) {
          const groups = res.response || [];
          this.groupOptions = groups;
          const groupSearch = this.searchList.find(i => i.key === "GroupId");
          if (groupSearch) {
            groupSearch.options = [{ label: "全部", value: null }, ...groups.map(g => ({ label: g.GroupName, value: g.Id }))];
          }
        }
      });
    },
    // 工具栏回调
    callFunction(item) {
      if (item.Func === "handleQuery") {
        this.filters.Page = 1;
        this.filters = { ...this.filters, ...item.search };
        if (this.filters.GroupId) {
          this.loadTextbookOptions(this.filters.GroupId);
          this.loadAssignTeacherOptions(this.filters.GroupId);
        }
        if (this.filters.TextbookId) this.loadUnitOptions(this.filters.TextbookId);
        this.getList();
      } else if (item.Func === "exportExcel") {
        this.exportExcel();
      } else if (this[item.Func]) {
        this[item.Func].apply(this, [item]);
      }
    },
    loadTextbookOptions(groupId) {
      const bookSearch = this.searchList.find(i => i.key === "TextbookId");
      const unitSearch = this.searchList.find(i => i.key === "UnitId");
      if (!groupId) {
        if (bookSearch) bookSearch.options = [];
        if (unitSearch) unitSearch.options = [];
        return;
      }
      getTextbooks({ groupId }).then(res => {
        if (!res.success || !bookSearch) return;
        bookSearch.options = [
          { label: "全部", value: null },
          ...(res.response || []).map(b => ({ label: b.Title, value: b.Id }))
        ];
      });
    },
    loadAssignTeacherOptions(groupId) {
      const item = this.searchList.find(i => i.key === "AssignedTeacherMasterId");
      if (!item) return;
      if (!groupId) {
        item.options = [];
        return;
      }
      getGroupTeachers({ groupId }).then(res => {
        if (!res.success) return;
        item.options = [
          { label: "全部", value: null },
          ...(res.response || []).map(t => ({ label: t.TeacherName, value: t.TeacherMasterId }))
        ];
      });
    },
    loadUnitOptions(textbookId) {
      const unitSearch = this.searchList.find(i => i.key === "UnitId");
      if (!unitSearch) return;
      if (!textbookId) {
        unitSearch.options = [];
        return;
      }
      getCatalogTree({ textbookId }).then(res => {
        if (!res.success) return;
        const tree = res.response || {};
        const units = tree.Units || tree.units || [];
        unitSearch.options = [
          { label: "全部", value: null },
          ...units.map(u => ({ label: u.UnitName, value: u.Id }))
        ];
      });
    },
    async exportExcel() {
      if (!normalizeDeptId(this.SchoolId)) {
        this.$message({ message: "当前处于总平台状态，请先从左侧选择具体的机构/学校再进行导出", type: "error" });
        return;
      }

      try {
        let para = {
          SchoolId: this.SchoolId,
          ...this.filters
        };

        const response = await exportPrepDocument(para);
        if (!response.data) {
          this.$message.error("导出数据为空");
          return;
        }

        let fileName = "备课文档导出";
        const disposition = response.headers['content-disposition'];
        if (disposition) {
          const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
          const matches = filenameRegex.exec(disposition);
          if (matches != null && matches[1]) {
            fileName = decodeURIComponent(matches[1].replace(/['"]/g, ''));
            if (fileName.toLowerCase().startsWith("utf-8''")) {
              fileName = decodeURIComponent(fileName.substring(7));
            }
          }
        }
        if (!fileName.endsWith(".xlsx")) fileName += ".xlsx";

        const blob = new Blob([response.data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
        const url = URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', fileName);
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        URL.revokeObjectURL(url);

        this.$message.success("导出成功");
      } catch (error) {
        console.error('导出失败:', error);
        this.$message.error("导出失败");
      }
    },
    // 预览/下载
    formatSimpleDateTime(date) {
      if (!date) return "-";
      return util.formatDate.format(new Date(date), "yyyy-MM-dd HH:mm");
    },
    formatDateTime(date) {
      if (!date) return "-";
      return util.formatDate.format(new Date(date), "yyyy-MM-dd HH:mm:ss");
    },
    // 获取详情
    handleDetail(row) {
      if (!row || !row.Id) return;

      this.listLoading = true;
      getPrepDocumentDetail({ docId: row.Id }).then((res) => {
        if (res.success) {
          this.detailData = res.response;
          this.reviewPage = 1;
          this.detailTab = "content";
          this.activeDiscussionIds = [];
          this.detailVisible = true;
        } else {
          this.$message.error(res.msg || "获取详情失败");
        }
        this.listLoading = false;
      });
    },
    async handlePreview(file) {
      if (!file) return;
      const rawUrl = file.FileUrl || '';
      const stableUrl = stripOssUrlQuery(rawUrl);
      const fullUrl = this.$resolveImageSrc(rawUrl);
      this.currentPreviewName = file.FileName || '文件预览';

      const ext = (file.FileType || '').toLowerCase();
      const isOffice = ['.doc', '.docx', '.xls', '.xlsx', '.ppt', '.pptx'].includes(ext);
      const schoolId = getUploadSchoolId(this);

      const loadAccessUrl = async () => {
        return resolveAttachmentAccessUrl(stableUrl || rawUrl, schoolId, { inline: true });
      };

      if (isOffice) {
        let isInternal = false;
        try {
          const url = new URL(fullUrl);
          const host = url.hostname;
          isInternal = host === 'localhost' ||
            host === '127.0.0.1' ||
            host.startsWith('192.168.') ||
            host.startsWith('10.') ||
            (host.startsWith('172.') && parseInt(host.split('.')[1]) >= 16 && parseInt(host.split('.')[1]) <= 31);
        } catch (e) { isInternal = true; }

        if (isInternal) {
          this.previewHintFile = file;
          this.previewHintVisible = true;
          return;
        }

        const loading = this.$loading({ lock: true, text: '加载预览...' });
        try {
          const accessUrl = await loadAccessUrl();
          this.previewUrlRaw = accessUrl;
          this.previewUrl = `https://view.officeapps.live.com/op/view.aspx?src=${encodeURIComponent(accessUrl)}`;
          this.previewVisible = true;
        } catch (e) {
          this.$message.error((e && e.message) || '获取预览地址失败，请尝试下载后查看');
        } finally {
          loading.close();
        }
      } else {
        const loading = this.$loading({ lock: true, text: '加载预览...' });
        try {
          const accessUrl = await loadAccessUrl();
          this.previewUrlRaw = accessUrl;
          this.previewUrl = accessUrl;
          this.previewVisible = true;
        } catch (e) {
          this.$message.error((e && e.message) || '获取文件预览地址失败');
        } finally {
          loading.close();
        }
      }
    },
    onPreviewHintClosed() {
      this.previewHintFile = null;
    },
    getFileIcon(ext) {
      const e = (ext || '').toLowerCase();
      if (['.jpg', '.jpeg', '.png', '.gif', '.webp'].includes(e)) return 'el-icon-picture';
      if (['.doc', '.docx'].includes(e)) return 'el-icon-document';
      if (['.xls', '.xlsx'].includes(e)) return 'el-icon-s-grid';
      if (['.ppt', '.pptx'].includes(e)) return 'el-icon-monitor';
      if (e === '.pdf' || e === 'pdf') return 'el-icon-reading';
      if (e === '.txt') return 'el-icon-document-copy';
      return 'el-icon-files';
    },
    getAttachmentCounts(attachments) {
      const counts = {};
      attachments.forEach(file => {
        let ext = (file.FileType || "").toLowerCase().replace(".", "");
        if (!ext) ext = "未知";
        counts[ext] = (counts[ext] || 0) + 1;
      });
      return counts;
    },
    // 分页
    handleSizeChange(val) {
      this.filters.PageSize = val;
      this.getList();
    },
    handleCurrentChange(val) {
      this.filters.Page = val;
      this.getList();
    },
    handleNodeClick(node) {
      if (!node || !node.value) return;
      this.SchoolId = node.value;
      this.filters.Page = 1;

      if (this.$refs.toolbar) {
        this.filters.GroupId = null;
        this.filters.Title = "";
        this.filters.UploadTimeFrom = null;
        this.filters.UploadTimeTo = null;
        this.filters.TextbookId = null;
        this.filters.UnitId = null;
        this.filters.OnlyLegacyDoc = null;

        this.$refs.toolbar.searchObj = {
          GroupId: null,
          Title: "",
          UploadTimeFrom: null,
          UploadTimeTo: null,
          TextbookId: null,
          UnitId: null,
          OnlyLegacyDoc: null,
          WorkflowStatus: this.filters.WorkflowStatus
        };
      } else {
        this.filters.Title = "";
        this.filters.GroupId = null;
        this.filters.UploadTimeFrom = null;
        this.filters.UploadTimeTo = null;
      }

      this.loadGroups(this.SchoolId); // 加载该校教研组可选项
      this.getList();
      this.tryOpenFromQuery();
    },
    applyRouteQuery() {
      const q = this.$route.query || {};
      if (q.WorkflowStatus != null && q.WorkflowStatus !== "") {
        this.filters.WorkflowStatus = Number(q.WorkflowStatus);
        const wfSearch = this.searchList.find(i => i.key === "WorkflowStatus");
        if (wfSearch) wfSearch.initValue = this.filters.WorkflowStatus;
      }
      if (q.GroupId) this.filters.GroupId = Number(q.GroupId);
      if (q.OnlyLegacyDoc === "1" || q.OnlyLegacyDoc === "true") {
        this.filters.OnlyLegacyDoc = true;
      }
    },
    tryOpenFromQuery() {
      const openId = this.$route.query.OpenDocId || this.$route.query.docId;
      if (!openId) return;
      this.handleDetail({ Id: Number(openId) });
    }
  },
  mounted() {
    let routers = window.localStorage.router ? JSON.parse(window.localStorage.router) : [];
    const allButtons = getButtonList(this.$route.path, routers) || [];
    // 工具栏只留查询/导出；代操作放到详情里，避免一排蓝按钮无从下手
    const toolbarFuncs = ["handleQuery", "exportExcel"];
    this.buttonList = allButtons.filter(b => toolbarFuncs.includes(b.Func));
    this.applyRouteQuery();
    // 显式同步初始值到 toolbar 组件
    if (this.$refs.toolbar) {
      this.$refs.toolbar.searchObj = { ...this.$refs.toolbar.searchObj, ...this.filters };
    }
  }
};
</script>

<style scoped>
/* —— 备课明细弹窗（pp-*）—— */
.pp-detail {
  --pp-primary: #1e3a8a;
  --pp-primary-soft: #eff6ff;
  --pp-text: #0f172a;
  --pp-muted: #64748b;
  --pp-line: #e2e8f0;
  --pp-bg: #f8fafc;
  color: var(--pp-text);
}

.pp-hero {
  padding: 4px 2px 16px;
  border-bottom: 1px solid var(--pp-line);
  margin-bottom: 4px;
}

.pp-hero__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
}

.pp-hero__title {
  margin: 0;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #0f172a;
  line-height: 1.35;
}

.pp-status {
  flex-shrink: 0;
  font-size: 12px;
  font-weight: 600;
  padding: 4px 10px;
  border-radius: 999px;
  border: 1px solid transparent;
  white-space: nowrap;
}

.pp-status--ok {
  background: #ecfdf5;
  color: #047857;
  border-color: #a7f3d0;
}

.pp-status--ready {
  background: var(--pp-primary-soft);
  color: #1e3a8a;
  border-color: #bfdbfe;
}

.pp-status--fail {
  background: #fef2f2;
  color: #b91c1c;
  border-color: #fecaca;
}

.pp-status--warn {
  background: #fffbeb;
  color: #b45309;
  border-color: #fde68a;
}

.pp-status--info {
  background: #f0f9ff;
  color: #3b82f6;
  border-color: #bae6fd;
}

.pp-status--muted {
  background: #f1f5f9;
  color: #64748b;
  border-color: #e2e8f0;
}

.pp-meta {
  list-style: none;
  margin: 14px 0 0;
  padding: 12px 14px;
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 10px 16px;
  background: linear-gradient(180deg, var(--pp-primary-soft) 0%, #fff 72%);
  border: 1px solid #dbeafe;
  border-radius: 12px;
}

.pp-meta li {
  display: flex;
  flex-direction: column;
  gap: 2px;
  min-width: 0;
}

.pp-meta__k {
  font-size: 11px;
  font-weight: 600;
  color: #678;
  letter-spacing: 0.02em;
}

.pp-meta__v {
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pp-meta__op {
  flex-direction: row !important;
  align-items: center;
  flex-wrap: wrap;
  gap: 6px !important;
}

.pp-meta__op .pp-meta__k {
  width: 100%;
}

.pp-link {
  border: none;
  background: transparent;
  color: var(--pp-primary);
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  padding: 0 2px;
  transition: color 0.2s ease;
}

.pp-link:hover {
  color: #1e3a8a;
  text-decoration: underline;
}

.pp-lessons {
  margin-top: 12px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 6px;
}

.pp-lessons__label {
  font-size: 12px;
  color: var(--pp-muted);
  margin-right: 4px;
}

.pp-chip {
  font-size: 12px;
  font-weight: 600;
  color: #1e3a8a;
  background: #fff;
  border: 1px solid #bfdbfe;
  border-radius: 6px;
  padding: 2px 8px;
}

.pp-callout {
  margin-top: 12px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px 12px;
  background: #fffbeb;
  border: 1px solid #fde68a;
  border-radius: 10px;
}

.pp-callout>i {
  color: #d97706;
  font-size: 18px;
}

.pp-callout__body {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
  font-size: 12px;
  color: #92400e;
}

.pp-callout__body strong {
  font-size: 13px;
  color: #78350f;
}

.pp-callout__btn {
  flex-shrink: 0;
  border: 1px solid #f59e0b;
  background: #fff;
  color: #b45309;
  font-size: 12px;
  font-weight: 700;
  border-radius: 8px;
  padding: 6px 12px;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
}

.pp-callout__btn:hover {
  background: #f59e0b;
  color: #fff;
}

.pp-pane {
  min-height: 280px;
  max-height: 48vh;
  overflow-y: auto;
  padding: 4px 2px 8px;
}

.pp-block+.pp-block {
  margin-top: 16px;
}

.pp-block__title {
  margin: 0 0 8px;
  font-size: 13px;
  font-weight: 700;
  color: #334155;
}

.pp-prose {
  margin: 0;
  padding: 14px 16px;
  background: #fff;
  border: 1px solid var(--pp-line);
  border-radius: 12px;
  font-size: 14px;
  line-height: 1.75;
  color: #334155;
  white-space: pre-wrap;
  max-height: 220px;
  overflow-y: auto;
}

.pp-files {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.pp-file {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 10px;
  background: #fff;
  border: 1px solid var(--pp-line);
  border-radius: 10px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease;
}

.pp-file:hover {
  border-color: #67e8f9;
  box-shadow: 0 4px 12px rgba(8, 145, 178, 0.08);
}

.pp-file__main {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
  gap: 10px;
  border: none;
  background: transparent;
  cursor: pointer;
  text-align: left;
  padding: 0;
}

.pp-file__icon {
  width: 36px;
  height: 36px;
  border-radius: 8px;
  background: var(--pp-bg);
  color: var(--pp-primary);
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 18px;
}

.pp-file__name {
  flex: 1;
  min-width: 0;
  font-size: 13px;
  font-weight: 600;
  color: #0f172a;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pp-file__size {
  font-size: 12px;
  color: var(--pp-muted);
}

.pp-file__ops {
  display: flex;
  gap: 6px;
}

.pp-file__dl {
  text-decoration: none;
}

.pp-icon-btn {
  width: 30px;
  height: 30px;
  border-radius: 8px;
  border: 1px solid #f1f5f9;
  background: var(--pp-bg);
  color: #94a3b8;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.2s ease;
}

.pp-icon-btn:hover {
  color: var(--pp-primary);
  border-color: #bfdbfe;
  background: var(--pp-primary-soft);
}

.pp-icon-btn.is-dl:hover {
  color: #059669;
  border-color: #a7f3d0;
  background: #ecfdf5;
}

.pp-empty {
  padding: 48px 16px;
  text-align: center;
  color: #94a3b8;
  font-size: 13px;
  background: var(--pp-bg);
  border: 1px dashed var(--pp-line);
  border-radius: 12px;
}

.pp-empty--sm {
  padding: 20px;
  margin-top: 8px;
}

.pp-review-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.pp-review {
  padding-bottom: 12px;
  border-bottom: 1px dashed var(--pp-line);
}

.pp-review:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.pp-review__head {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-bottom: 6px;
}

.pp-review__head strong {
  font-size: 14px;
  color: #0f172a;
}

.pp-review__head time {
  margin-left: auto;
  font-size: 12px;
  color: #94a3b8;
}

.pp-review__body {
  margin: 0;
  padding: 8px 12px;
  font-size: 13px;
  line-height: 1.6;
  color: #475569;
  background: var(--pp-bg);
  border-radius: 8px;
}

.pp-pager {
  margin-top: 12px;
  padding-top: 12px;
  border-top: 1px solid #f1f5f9;
  display: flex;
  justify-content: center;
}

.pp-pill {
  font-size: 11px;
  font-weight: 700;
  padding: 1px 7px;
  border-radius: 4px;
  background: #f1f5f9;
  color: #64748b;
  border: 1px solid #e2e8f0;
}

.pp-pill--ok {
  background: #ecfdf5;
  color: #047857;
  border-color: #a7f3d0;
}

.pp-pill--warn {
  background: #fffbeb;
  color: #b45309;
  border-color: #fde68a;
}

.pp-pill--amber {
  background: #fffbeb;
  color: #d97706;
  border-color: #fde68a;
}

.pp-collapse__title {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  font-weight: 600;
}

.pp-collapse__title time {
  font-weight: 400;
  color: #94a3b8;
  font-size: 12px;
}

.pp-collapse__foot {
  margin-top: 10px;
  text-align: right;
}

.pp-msg {
  padding: 8px 0;
  border-bottom: 1px solid #f1f5f9;
}

.pp-msg:last-child {
  border-bottom: none;
}

.pp-msg__meta {
  font-size: 12px;
  color: #94a3b8;
  margin-bottom: 4px;
}

.pp-msg__text {
  font-size: 13px;
  color: #334155;
  line-height: 1.55;
}

.pp-footer {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  width: 100%;
}

.pp-footer__left {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
}

@media (max-width: 900px) {
  .pp-meta {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}

@media (prefers-reduced-motion: reduce) {

  .pp-file,
  .pp-icon-btn,
  .pp-link,
  .pp-callout__btn {
    transition: none;
  }
}

/* 内网预览提示 */
.wr-hint__hero {
  text-align: center;
  padding: 4px 8px 0;
}

.wr-hint__icon {
  width: 56px;
  height: 56px;
  margin: 0 auto 14px;
  border-radius: 50%;
  background: linear-gradient(145deg, #fff7e6, #ffe7ba);
  color: #e6a23c;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 28px;
  box-shadow: 0 4px 14px rgba(230, 162, 60, 0.2);
}

.wr-hint__title {
  margin: 0 0 8px;
  font-size: 18px;
  font-weight: 700;
  color: #1e293b;
}

.wr-hint__desc {
  margin: 0;
  font-size: 14px;
  line-height: 1.65;
  color: #64748b;
}

.wr-hint__desc strong {
  color: #475569;
  font-weight: 600;
}

.wr-hint__steps {
  margin-top: 20px;
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.wr-hint__step {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 14px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
}

.wr-hint__step-no {
  flex-shrink: 0;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  background: #eff6ff;
  color: #1e3a8a;
  font-size: 13px;
  font-weight: 700;
  display: flex;
  align-items: center;
  justify-content: center;
}

.wr-hint__step-title {
  font-size: 14px;
  font-weight: 600;
  color: #334155;
  margin-bottom: 4px;
}

.wr-hint__step-text {
  font-size: 13px;
  line-height: 1.55;
  color: #64748b;
}

.wr-hint__file {
  margin-top: 14px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 10px 12px;
  background: #fff;
  border: 1px dashed #d0d7e2;
  border-radius: 8px;
  color: #475569;
  font-size: 13px;
}

.wr-hint__file i {
  font-size: 18px;
  color: #1e3a8a;
}

.wr-hint__file-name {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.wr-hint__footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
}

.wr-hint__dl-link {
  text-decoration: none;
}

/* 绑定课时：列表省略，点击弹窗看全 */
.pd-lesson-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  max-width: 100%;
  color: #1e3a8a;
  cursor: pointer;
  font-weight: 500;
  font-size: 12px;
}

.pd-lesson-link:hover {
  text-decoration: underline;
}

.pd-lesson-link__text {
  display: inline-block;
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  vertical-align: bottom;
}

.pd-lesson-dialog__sub {
  margin: 0 0 12px;
  font-size: 13px;
  color: #64748b;
}

.pd-lesson-dialog__list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  max-height: 360px;
  overflow-y: auto;
}

.pd-lesson-dialog__item {
  padding: 8px 12px;
  border-radius: 8px;
  background: #eff6ff;
  border: 1px solid #dbeafe;
  color: #1e3a8a;
  font-size: 13px;
  line-height: 1.45;
  word-break: break-all;
}

.pd-lesson-dialog__path {
  font-weight: 600;
  color: #0f172a;
}

.pd-lesson-dialog__name {
  margin-top: 4px;
  font-size: 12px;
  color: #1e3a8a;
}

.pd-lesson-dialog__name.is-empty {
  color: #94a3b8;
}

/* 列表内容溢出处理 */
.v9-content-ellipsis {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
  /* 最多显示2行 */
  line-clamp: 2;
  overflow: hidden;
  text-overflow: ellipsis;
  color: #64748b;
  font-size: 13px;
  line-height: 1.6;
}

/* 评价记录样式 */
.v9-review-list {
  display: flex;
  flex-direction: column;
  gap: 12px;
  flex: 1;
  overflow-y: auto;
  padding-right: 8px;
}

.v9-review-pagination {
  margin-top: 12px;
  display: flex;
  justify-content: center;
  border-top: 1px solid #f1f5f9;
  padding: 12px 0 4px 0;
}

.detail-left-panel,
.detail-right-panel {
  display: flex;
  flex-direction: column;
  height: 650px;
}

.detail-right-panel {
  border-left: 1px solid #f1f5f9;
  padding-left: 24px !important;
}

.detail-right-panel .section-v9 {
  flex: 1;
  display: flex;
  flex-direction: column;
}

.reviews-card {
  flex: 1;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  /* 强制内部滚动 */
}

/* 自定义滚动条 - 极简纤细风格 */
.v9-review-list::-webkit-scrollbar,
.description-card::-webkit-scrollbar,
.premium-dialog .el-dialog__body::-webkit-scrollbar {
  width: 5px;
}

.v9-review-list::-webkit-scrollbar-thumb,
.description-card::-webkit-scrollbar-thumb,
.premium-dialog .el-dialog__body::-webkit-scrollbar-thumb {
  background: #e2e8f0;
  border-radius: 10px;
}

.v9-review-list::-webkit-scrollbar-thumb:hover,
.description-card::-webkit-scrollbar-thumb:hover,
.premium-dialog .el-dialog__body::-webkit-scrollbar-thumb:hover {
  background: #cbd5e1;
}

.v9-review-list::-webkit-scrollbar-track,
.description-card::-webkit-scrollbar-track,
.premium-dialog .el-dialog__body::-webkit-scrollbar-track {
  background: transparent;
}

.v9-review-item {
  padding-bottom: 12px;
  border-bottom: 1px dashed #e2e8f0;
}

.v9-review-item:last-child {
  border-bottom: none;
  padding-bottom: 0;
}

.v9-review-header {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 6px;
}

.v9-reviewer {
  font-size: 14px;
  font-weight: 700;
  color: #1e293b;
}

.v9-score-badge {
  font-size: 12px;
  font-weight: 700;
  color: #f59e0b;
  background: #fffbe6;
  padding: 2px 8px;
  border-radius: 6px;
  border: 1px solid #ffe58f;
}

.v9-tag-valid {
  font-size: 11px;
  font-weight: 700;
  color: #10b981;
  background: #ecfdf5;
  padding: 1px 6px;
  border-radius: 4px;
  border: 1px solid #a7f3d0;
}

.v9-tag-invalid {
  font-size: 11px;
  font-weight: 700;
  color: #94a3b8;
  background: #f1f5f9;
  padding: 1px 6px;
  border-radius: 4px;
  border: 1px solid #e2e8f0;
}

.v9-review-time {
  font-size: 12px;
  color: #94a3b8;
  margin-left: auto;
}

.v9-review-content {
  font-size: 13px;
  color: #475569;
  line-height: 1.6;
  background: #f8fafc;
  padding: 8px 12px;
  border-radius: 8px;
}
</style>

<style>
.el-dialog.wr-preview-hint-dialog {
  border-radius: 14px !important;
  overflow: hidden !important;
  box-shadow: 0 20px 48px rgba(15, 23, 42, 0.14) !important;
}

.el-dialog.wr-preview-hint-dialog .el-dialog__header {
  padding: 14px 18px 0 !important;
  border-bottom: none !important;
  background: #fff !important;
}

.el-dialog.wr-preview-hint-dialog .el-dialog__title {
  display: none;
}

.el-dialog.wr-preview-hint-dialog .el-dialog__headerbtn {
  top: 14px;
  right: 14px;
}

.el-dialog.wr-preview-hint-dialog .el-dialog__body {
  padding: 8px 22px 6px !important;
  background: #fff !important;
}

.el-dialog.wr-preview-hint-dialog .el-dialog__footer {
  padding: 12px 22px 18px !important;
  border-top: 1px solid #f1f5f9;
  background: #fff !important;
}

/* 备课明细弹窗（append-to-body，需非 scoped） */
.el-dialog.pp-detail-dialog {
  border-radius: 16px !important;
  overflow: hidden !important;
  box-shadow: 0 24px 48px rgba(15, 23, 42, 0.16) !important;
  border: 1px solid #e2e8f0 !important;
}

.el-dialog.pp-detail-dialog .el-dialog__header {
  padding: 16px 22px 12px !important;
  background: #fff !important;
  border-bottom: 1px solid #f1f5f9 !important;
}

.el-dialog.pp-detail-dialog .el-dialog__headerbtn {
  top: 18px;
  right: 18px;
}

.el-dialog.pp-detail-dialog .el-dialog__headerbtn .el-dialog__close {
  color: #94a3b8;
}

.el-dialog.pp-detail-dialog .el-dialog__headerbtn:hover .el-dialog__close {
  color: #1e3a8a;
}

.el-dialog.pp-detail-dialog .el-dialog__body {
  padding: 8px 22px 12px !important;
  background: #fff !important;
  max-height: none !important;
  overflow: hidden !important;
}

.el-dialog.pp-detail-dialog .el-dialog__footer {
  padding: 12px 22px 16px !important;
  background: #f8fafc !important;
  border-top: 1px solid #e2e8f0 !important;
}

.pp-dialog-title {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  padding-right: 28px;
}

.pp-dialog-title__mark {
  width: 4px;
  height: 34px;
  margin-top: 2px;
  border-radius: 4px;
  background: linear-gradient(180deg, #1e3a8a, #3b82f6);
  flex-shrink: 0;
}

.pp-dialog-title__main {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
  line-height: 1.3;
}

.pp-dialog-title__sub {
  margin-top: 2px;
  font-size: 12px;
  color: #94a3b8;
  font-weight: 400;
}

.el-dialog.pp-detail-dialog .pp-tabs>.el-tabs__header {
  margin: 0 0 12px !important;
}

.el-dialog.pp-detail-dialog .pp-tabs>.el-tabs__header .el-tabs__nav-wrap::after {
  height: 1px;
  background-color: #e2e8f0;
}

.el-dialog.pp-detail-dialog .pp-tabs .el-tabs__item {
  height: 40px;
  line-height: 40px;
  font-size: 13px;
  font-weight: 600;
  color: #64748b;
  padding: 0 16px !important;
}

.el-dialog.pp-detail-dialog .pp-tabs .el-tabs__item.is-active {
  color: #1e3a8a;
}

.el-dialog.pp-detail-dialog .pp-tabs .el-tabs__active-bar {
  background-color: #1e3a8a;
  height: 3px;
  border-radius: 3px 3px 0 0;
}

.el-dialog.pp-detail-dialog .pp-tab-label {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.el-dialog.pp-detail-dialog .pp-tab-label em {
  font-style: normal;
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  border-radius: 9px;
  background: #f1f5f9;
  color: #64748b;
  font-size: 11px;
  font-weight: 700;
  display: inline-flex;
  align-items: center;
  justify-content: center;
}

.el-dialog.pp-detail-dialog .el-tabs__item.is-active .pp-tab-label em {
  background: #eff6ff;
  color: #1e3a8a;
}

.el-dialog.pp-detail-dialog .pp-table {
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow: hidden;
}

.el-dialog.pp-detail-dialog .pp-table::before {
  display: none;
}

.el-dialog.pp-detail-dialog .pp-table th {
  background: #f8fafc !important;
  color: #475569;
  font-weight: 700;
}

.el-dialog.pp-detail-dialog .pp-collapse {
  border: none;
}

.el-dialog.pp-detail-dialog .pp-collapse .el-collapse-item {
  margin-bottom: 8px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow: hidden;
}

.el-dialog.pp-detail-dialog .pp-collapse .el-collapse-item__header {
  height: 44px;
  line-height: 44px;
  padding: 0 14px;
  background: #f8fafc;
  border-bottom: none;
  font-weight: 600;
}

.el-dialog.pp-detail-dialog .pp-collapse .el-collapse-item__wrap {
  border-bottom: none;
}

.el-dialog.pp-detail-dialog .pp-collapse .el-collapse-item__content {
  padding: 8px 14px 12px;
}

.el-dialog.pp-detail-dialog .pp-btn-primary {
  background-color: #1e3a8a !important;
  border-color: #1e3a8a !important;
}

.el-dialog.pp-detail-dialog .pp-btn-primary:hover {
  background-color: #1e3a8a !important;
  border-color: #1e3a8a !important;
}

/* 巅峰设计版系统弹窗全局样式 - 支持 append-to-body */
.premium-dialog {
  border-radius: 20px !important;
  overflow: hidden !important;
  box-shadow: 0 25px 50px -12px rgba(0, 0, 0, 0.15) !important;
  border: 1px solid rgba(255, 255, 255, 0.8) !important;
}

.premium-dialog .el-dialog__header {
  padding: 16px 24px !important;
  background: #ffffff !important;
  border-bottom: 2px solid #f1f5f9 !important;
}

.premium-dialog .el-dialog__body {
  background: #fcfdfe !important;
  padding: 16px 24px 24px 24px !important;
  max-height: 75vh !important;
  overflow-y: auto !important;
}

/* 预览模式下的特殊样式 */
.premium-dialog.is-preview-mode {
  width: 96vw !important;
  max-width: none !important;
  margin-top: 1vh !important;
  height: 94vh !important;
  display: flex !important;
  flex-direction: column !important;
}

.premium-dialog.is-preview-mode .el-dialog__body {
  padding: 0 !important;
  flex: 1 !important;
  overflow: hidden !important;
  display: flex !important;
  flex-direction: column !important;
  max-height: none !important;
  /* 覆盖常规弹窗的限制 */
}

.premium-dialog.v9-detail-dialog .el-dialog__body {
  overflow: hidden !important;
  padding: 20px 24px 20px 24px !important;
}

.premium-dialog.is-preview-mode .el-dialog__header {
  padding: 10px 20px !important;
  border-bottom: 1px solid #eee !important;
}

.preview-container {
  display: flex !important;
  flex-direction: column !important;
  height: 100% !important;
}

.preview-toolbar {
  height: 50px !important;
  display: flex !important;
  align-items: center !important;
  justify-content: space-between !important;
  padding: 0 20px !important;
  background: #f8fafc !important;
  border-bottom: 1px solid #e2e8f0 !important;
}

.preview-filename {
  font-weight: 700 !important;
  color: #1e293b !important;
}

.preview-frame-wrapper {
  flex: 1 !important;
  background: #f1f5f9 !important;
}

.preview-iframe {
  width: 100% !important;
  height: 100% !important;
}
</style>

<style scoped>
.v9-header {
  padding: 0 0 4px 0;
}

.v9-teacher-info h1 {
  font-size: 24px;
  font-weight: 800;
  color: #1e293b;
  margin: 0;
  letter-spacing: -0.025em;
}

.v9-badges {
  margin-top: 10px;
  display: flex;
  align-items: center;
  gap: 12px;
}

.v9-badge-pill {
  font-size: 11px;
  font-weight: 700;
  padding: 3px 10px;
  border-radius: 6px;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.v9-bg-indigo {
  background: #eff6ff;
  color: #1e3a8a;
}

.v9-meta-dot {
  width: 4px;
  height: 4px;
  background: #cbd5e1;
  border-radius: 50%;
}

.v9-class-info,
.v9-date-info {
  font-size: 13px;
  font-weight: 600;
  color: #64748b;
}

.section-v9 {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.v9-section-header {
  display: flex;
  align-items: center;
  gap: 10px;
}

.v9-accent {
  width: 4px;
  height: 16px;
  background: #1e3a8a;
  border-radius: 4px;
}

.v9-section-header h3 {
  font-size: 14px;
  font-weight: 800;
  color: #475569;
  margin: 0;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

.v9-section-header h3 small {
  font-weight: 500;
  color: #94a3b8;
  margin-left: 4px;
}

.v9-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 12px 16px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.05);
}

.description-card {
  max-height: 250px;
  overflow-y: auto;
}

/* 左侧面板滚动美化 */
.detail-left-panel {
  overflow-y: auto;
  padding-right: 12px;
  gap: 20px;
}

.v9-content-text {
  margin: 0;
  line-height: 1.8;
  color: #334155;
  font-size: 15px;
  white-space: pre-wrap;
}

.v9-attachment-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 12px;
}

.v9-file-item {
  display: flex;
  align-items: center;
  padding: 10px 12px;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s cubic-bezier(0.4, 0, 0.2, 1);
}

.v9-file-item:hover {
  border-color: #1e3a8a;
  background: #eff6ff;
  transform: translateY(-2px);
  box-shadow: 0 10px 15px -3px rgba(30, 58, 138, 0.1);
}

.v9-file-icon {
  width: 44px;
  height: 44px;
  background: #f8fafc;
  color: #64748b;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  margin-right: 16px;
}

.v9-file-item:hover .v9-file-icon {
  background: #dbeafe;
  color: #1e3a8a;
}

.v9-file-info {
  flex: 1;
  min-width: 0;
}

.v9-fn {
  font-size: 14px;
  font-weight: 700;
  color: #1e293b;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.v9-fm {
  font-size: 12px;
  color: #94a3b8;
  font-weight: 500;
  margin-top: 2px;
}

.v9-file-main {
  flex: 1;
  min-width: 0;
  display: flex;
  align-items: center;
}

.v9-file-actions-group {
  display: flex;
  gap: 8px;
  margin-left: 12px;
}

.v9-action-btn {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  background: #f8fafc;
  transition: all 0.2s ease;
  cursor: pointer;
  border: 1px solid #f1f5f9;
}

.v9-action-btn:hover {
  background: #eff6ff;
  color: #1e3a8a;
  border-color: #bfdbfe;
}

.v9-action-btn.is-download:hover {
  background: #ecfdf5;
  color: #10b981;
}

.v9-dl-link {
  text-decoration: none;
}

.v9-empty-attachments {
  grid-column: 1 / -1;
  background: #f8fafc;
  border: 2px dashed #e2e8f0;
  border-radius: 12px;
  padding: 30px;
  text-align: center;
  color: #94a3b8;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

/* 移除旧的预览容器样式，已移入全局样式块 */
</style>
